import classNames from "classnames"
import React, { useRef } from "react"
import { InputFileIcon } from "../common/Icons"

import s from "./Form.module.scss"

export default function Input({
  className,
  errorMessage,
  fileInputText,
  label,
  name,
  onChange,
  placeholder,
  type = "text",
  value,
}) {
  const id = `field-${name}`
  const fileInputRef = useRef()

  const triggerFileInput = (e) => {
    e.preventDefault()
    fileInputRef.current.click()
  }

  return (
    <div
      className={classNames(s.formField, className, {
        [s.error]: errorMessage,
      })}
    >
      <label htmlFor={id}>{label}</label>
      {type === "file" ? (
        <input
          id={id}
          name={name}
          onChange={onChange}
          ref={fileInputRef}
          style={{
            display: "none",
          }}
          type={type}
          value={value}
        />
      ) : (
        <input
          id={id}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          type={type}
          value={value}
        />
      )}

      {type === "file" && (
        <button className={s.customFileInput} onClick={triggerFileInput}>
          {fileInputRef?.current?.files[0]?.name ? (
            <span>{fileInputRef.current.files[0].name}</span>
          ) : (
            fileInputText
          )}
          <InputFileIcon />
        </button>
      )}

      {errorMessage ? (
        <span className={s.errorLabel}>{errorMessage}</span>
      ) : null}
    </div>
  )
}
